import React from 'react'
import dynamic from 'next/dynamic'
import Experiment from '@mc/experiments-react'
import { Variant2HPQuiz } from './Variant2HPQuiz'
import { HP_INNOVATIVE_SWING_FLAG_NAME } from './constants'

const CinematicHero = dynamic(
  () => import('./CinematicHero').then((mod) => mod.CinematicHero),
  { ssr: true },
)

interface HeroQuizExpWrapperProps {
  Control: React.ReactNode
}

export const HeroQuizExpWrapper = ({ Control }: HeroQuizExpWrapperProps) => (
  <Experiment
    name={HP_INNOVATIVE_SWING_FLAG_NAME}
    control={() => Control}
    variant_1={CinematicHero}
    variant_2={Variant2HPQuiz}
  />
)
